<template>
	<div class="dashboard">
		<app-header/>

		<div class="container">
			<div class="row">
				
				<div class="col-sm-6">
					<div class="box-dashboard">
						<div class="bd-header">
							Entradas ultimo dia
						</div>

						<div class="bd-body expo">
							<h2>${{money(user.incomign)}}</h2>
							<p>Dinero en recaudos</p>
						</div>
					</div>
				</div>

				

				<div class="col-sm-6">
					<div class="box-dashboard">
						<div class="bd-header">
							Compras ultimo dia
						</div>

						<div class="bd-body expo">
							<h2>${{money(user.lastDay)}}</h2>
							<p>Dinero en recaudos</p>
						</div>
					</div>
				</div>




				<div class="col-md-12">
					<h2>{{$t('dashboard.last_transactions')}}</h2>
					<div class="table table-padded">
						<table>
							<thead>
								<tr>
									<th>{{$t('table.status')}}</th>
									<th>{{$t('table.type')}}</th>
									<th>{{$t('table.id')}}</th>
									<th>{{$t('table.date')}}</th>
									<th>{{$t('table.hour')}}</th>
									<th>{{$t('table.reference')}}</th>
									<th>{{$t('table.bank')}}</th>
									<th>{{$t('table.value')}}</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(transaction, index) in consignments" :key="index">
									<td>{{transaction.status}}</td>
									<td>
										<template v-if="transaction.eTransfer ==1">
											Transferencia
										</template>
										<template v-else>
						                  Consignación
						                </template>

									</td>
									<td>{{transaction.id}}</td>
									<td>{{transaction.createdAt.substr(0, 10)}}</td>
									<td>{{transaction.createdAt.substr(11, 5)}}</td>
									<td>{{transaction.reference}}</td>
									<td>
										<img :src="'/banks/'+transaction.bankImage" class="bank" v-b-modal.bankModal>
									</td>
									<td>
										<h2 class="itemIndicator" :class="transaction.type == 'add' ? 'low' : ''">${{money(transaction.amount)}}</h2>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				

			</div>
		</div>
			
		<app-footer/>


		<b-modal id="bankModal" hide-footer title="Estadisticas del banco">
			<h2>Recaudos:</h2>
			<h1>${{money(1560000)}}</h1>
		</b-modal>

	</div>
</template>


<script>
import { mapGetters } from "vuex";
import { FETCH_CONSIGNMENTS } from "@/store/actions.type";

import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";

export default {
  components: {
    AppHeader,
    AppFooter
  },

  methods: {},

  computed: {
    ...mapGetters(["consignments", "user"])
  },

  mounted() {
    this.$store.dispatch(FETCH_CONSIGNMENTS);
  }
};
</script>


<style lang="scss">
</style>
